import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import ChannelFactory from './ChannelFactory.vue';

import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';
import InboxHome from './Index.vue';
import Settings from './Settings.vue';
import InboxChannel from './InboxChannels.vue';
import ChannelList from './ChannelList.vue';
import AddAgents from './AddAgents.vue';
import FinishSetup from './FinishSetup.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/inboxes'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_inbox_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_inbox_list',
          component: InboxHome,
          meta: {
            featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
            permissions: ['administrator', 'inbox_manage'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/inboxes'),
      component: SettingsContent,
      props: params => {
        const showBackButton = params.name !== 'settings_inbox_list';
        const fullWidth = params.name === 'settings_inbox_show';
        const isChannelSetup = params.name === 'settings_inboxes_page_channel';
        return {
          headerTitle: 'INBOX_MGMT.HEADER',
          icon: 'mail-inbox-all',
          showBackButton,
          // Channel setup must always return to the channel selector. Browser
          // history can point to an unrelated page after an OAuth attempt.
          backUrl: isChannelSetup
            ? {
                name: 'settings_inbox_new',
                params: { accountId: params.params.accountId },
              }
            : '',
          fullWidth,
        };
      },
      children: [
        {
          path: 'new',
          component: InboxChannel,
          children: [
            {
              path: '',
              name: 'settings_inbox_new',
              component: ChannelList,
              meta: {
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator', 'inbox_manage'],
              },
            },
            {
              path: ':inbox_id/finish',
              name: 'settings_inbox_finish',
              component: FinishSetup,
              meta: {
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator', 'inbox_manage'],
              },
            },
            {
              path: ':sub_page',
              name: 'settings_inboxes_page_channel',
              component: ChannelFactory,
              meta: {
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator', 'inbox_manage'],
              },
              props: route => {
                return { channelName: route.params.sub_page };
              },
            },
            {
              path: ':inbox_id/agents',
              name: 'settings_inboxes_add_agents',
              meta: {
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator', 'inbox_manage'],
              },
              component: AddAgents,
            },
          ],
        },
        {
          path: ':inboxId/assignment-policy',
          name: 'settings_inbox_assignment_policy_index',
          redirect: to => ({
            name: 'settings_inbox_show',
            params: {
              accountId: to.params.accountId,
              inboxId: to.params.inboxId,
              tab: 'collaborators',
            },
          }),
          meta: {
            permissions: ['administrator', 'inbox_manage'],
          },
        },
        {
          path: ':inboxId/assignment-policy/create',
          name: 'settings_inbox_assignment_policy_create',
          redirect: to => ({
            name: 'settings_inbox_assignment_policy_index',
            params: {
              accountId: to.params.accountId,
              inboxId: to.params.inboxId,
            },
          }),
          meta: {
            permissions: ['administrator', 'inbox_manage'],
          },
        },
        {
          path: ':inboxId/assignment-policy/edit/:id',
          name: 'settings_inbox_assignment_policy_edit',
          redirect: to => ({
            name: 'settings_inbox_assignment_policy_index',
            params: {
              accountId: to.params.accountId,
              inboxId: to.params.inboxId,
            },
          }),
          meta: {
            permissions: ['administrator', 'inbox_manage'],
          },
        },
        {
          path: ':inboxId/:tab?',
          name: 'settings_inbox_show',
          component: Settings,
          meta: {
            featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
            permissions: ['administrator', 'inbox_manage'],
          },
        },
      ],
    },
  ],
};
